"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaDashboardFilter = exports.DashboardTypesNames = exports.DashboardKeysNames = void 0;
const yup = __importStar(require("yup"));
__exportStar(require("./react-grid-layout"), exports);
exports.DashboardKeysNames = [
    'NumeroGeralMatriculaAtivas',
    'RematriculaComAceiteEmContratoPrincipais',
    'PercentualDeAceitePorContrato',
    'EventoScheduler',
    'MatriculaDeAlunosPorAno',
    'MatriculaConfirmadaPorAno',
    'MatriculaDoAnoPorGrau',
    'MatriculasAnoAnteiorVsAtual',
    'AlunosAbaixoDaMediaMinEtapa',
    'PercentualEntregaNotas',
    'QuantidadeOcorrenciaPorDia',
    'ResponsaveisAceitaramPoliticaPrivacidade',
    'QuantidadeUsuariosUsandoDeltaClass',
    'ReceitasVsDespesas',
    'ResumoUltimos',
    'ResumoFinanceiro',
    'IndiceInadimplenciaPorMes',
    'BoletosRecebidosHoje',
    'ReceitaTotalComparadoMesAnterior',
    'FaturamentoMensal',
    'PrevisaoRecebimentos',
    'DespesaTotalComparadoMesAnterior',
    'ReceitaPorProduto',
    'ValoresAberto',
    'ValoresBaixadosLiquidadosDiaAnteriror',
    'ValoresTotaisGratuidades50_100PorCento',
    'AlunosComGratuidades50_100PorCento',
    'ValoresGratuidades50_100PorCento',
    'QuantidadeAlunosGratuidades50_100PorCento',
];
exports.DashboardTypesNames = ['academico', 'coordenacao', 'administrativo', 'financeiro'];
exports.schemaDashboardFilter = yup.object().shape({
    anoLetivo: yup.string().required().default(new Date().getFullYear().toString()).label('Ano letivo'),
    anoMatric: yup.string().required().default(new Date().getFullYear().toString()).label('Ano para matrículas'),
    nomeEtapa: yup.string().required().default('Bimestre').label('Nome da etapa'),
    idCurso: yup.string().label('Curso'),
    idSerie: yup.string().label('Série'),
    idTurma: yup.string().label('Turma'),
});
